"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateSingleSelect = exports.serializeSingleSelect = void 0;
const multiSelect_1 = require("./multiSelect");
const serializeSingleSelect = (item) => {
    return (0, multiSelect_1.serializeMultiSelect)(item);
};
exports.serializeSingleSelect = serializeSingleSelect;
const validateSingleSelect = (item) => {
    if (!item.required || item.data.items?.find((item) => item.checked)) {
        return { valid: true };
    }
    return { valid: false, error: { message: "Select one." } };
};
exports.validateSingleSelect = validateSingleSelect;
//# sourceMappingURL=singleSelect.js.map